import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes ,Redirect } from 'react-router-dom'
import './scss/style.scss'
import "src/assets/css/fullapp.css";
import { ToastNotificationContainer } from 'src/animation/notificationUtils';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import IFrame from './views/dashboard/Iframe';
import Config from './views/dashboard/Config';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layouts/DefaultLayout'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {



  render() {
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
             {/* <Route path="/" name="dashboard" element={<Dashboard />} /> */}
             <Route
              path="/dashboard/:client_id/:user_id/:module_id/:scenario_id/"
              name="dashboard"
              element={<IFrame />}
            />
             <Route path="/config/:client_id/:module_id/" name="config" element={<Config />} />
          </Routes>
        </Suspense>
        <ToastNotificationContainer />
      </BrowserRouter>
    )
  }
}

export default App
